import { AxiosResponse } from 'axios';
import { useMemo } from 'react';
import { PrizeRedemption } from '../../api/PrizeRedemption';
import { PrizeRedemptionTextSearchableFields } from '../../api/PrizeRedemption/PrizeRedemption.type';
import { useApiCall } from '../useApiCall';

export type UsePrizeRequestAutocompleteConfig = {
	prizeRequestClient?: PrizeRedemption;
};

export function usePrizeRequestAutocomplete(
	field: PrizeRedemptionTextSearchableFields | undefined,
	term: string,
	{ prizeRequestClient }: UsePrizeRequestAutocompleteConfig = {}
) {
	const client = useMemo(
		() => prizeRequestClient ?? new PrizeRedemption(),
		[prizeRequestClient]
	);
	const fetcher = useMemo(() => {
		if (field == null || !term || term.length < 3) return nullFetcher;
		return client.autocomplete;
	}, [field, term]);

	const requestParams: Parameters<typeof fetcher> = useMemo(
		() => [field, term],
		[field, term]
	);

	const { data: suggestions = [], loading } = useApiCall<
		string[] | undefined,
		Parameters<typeof fetcher>
	>(fetcher as any, requestParams as Parameters<typeof fetcher>);

	return {
		suggestions,
		loading,
	};
}

export async function nullFetcher(
	_field: PrizeRedemptionTextSearchableFields | undefined,
	_term: string
) {
	return {
		data: undefined,
	} as AxiosResponse;
}
